const sportsbookBetLinkOptions = {
    version: 1,
    defaultAllowClosestLine: true,
    defaultExcludeDfs: true,
    options: [
        {
            bookmakerKey: 'draftkings',
            displayName: 'DraftKings',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: true,
            multiPickConfidence: 'inferred',
            requiresState: false,
            statePlaceholder: false,
            uiRecommended: true
        },
        {
            bookmakerKey: 'hardrock',
            displayName: 'Hard Rock Bet',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: true,
            multiPickConfidence: 'validated',
            requiresState: false,
            statePlaceholder: false,
            uiRecommended: true
        },
        {
            bookmakerKey: 'caesars',
            displayName: 'Caesars',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: true,
            multiPickConfidence: 'inferred',
            requiresState: true,
            statePlaceholder: true,
            uiRecommended: true
        },
        {
            bookmakerKey: 'betmgm',
            displayName: 'BetMGM',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: true,
            multiPickConfidence: 'inferred',
            requiresState: true,
            statePlaceholder: true,
            uiRecommended: true
        },
        {
            bookmakerKey: 'fanduel',
            displayName: 'FanDuel',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: false,
            multiPickConfidence: 'unvalidated',
            requiresState: false,
            statePlaceholder: false,
            uiRecommended: true
        },
        {
            bookmakerKey: 'prizepicks',
            displayName: 'PrizePicks',
            category: 'dfs',
            singlePickSupported: true,
            multiPickSupported: true,
            multiPickConfidence: 'inferred',
            requiresState: false,
            statePlaceholder: false,
            uiRecommended: false
        },
        {
            bookmakerKey: 'espnbet',
            aliases: ['thescore'],
            displayName: 'ESPN Bet',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: false,
            multiPickConfidence: 'unvalidated',
            requiresState: false,
            statePlaceholder: false,
            uiRecommended: false
        },
        {
            bookmakerKey: 'betrivers',
            displayName: 'BetRivers',
            category: 'sportsbook',
            singlePickSupported: true,
            multiPickSupported: false,
            multiPickConfidence: 'unvalidated',
            requiresState: true,
            statePlaceholder: true,
            uiRecommended: false
        }
    ],
    unsupportedOutcomeLinkBooks: [
        'ballybet',
        'betonline',
        'betparx',
        'betus',
        'bovada',
        'fanatics',
        'fliff',
        'lowvig',
        'mybookie',
        'pick6',
        'pinnacle',
        'underdog'
    ]
};

export default sportsbookBetLinkOptions;
